import { CustomDataAttrGtmClick } from '../../../features/google/customDataType';
import { DefaultProps } from '../../../types/DefaultProps';
import { FiHeartIcon } from '../../Icon';

import styles from './ButtonFavorite.module.scss';

import type { FC } from 'react';

import { assertNever } from '@/packages/nurse-senka-frontend-sdk';

type ButtonActiveProps = {
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

// Default Styled
const ButtonFavoriteDefault: FC<ButtonActiveProps> = ({
  customDataAttrGtmClick,
}) => (
  <button
    className={styles['button-default']}
    aria-label="あとでみる"
    data-gtm-click={customDataAttrGtmClick}
  >
    <FiHeartIcon size={18} />
  </button>
);

// Active Styled
const ButtonFavoriteActive: FC<ButtonActiveProps> = ({
  customDataAttrGtmClick,
}) => (
  <button
    className={styles['button-active']}
    aria-label="あとでみる"
    data-gtm-click={customDataAttrGtmClick}
  >
    <FiHeartIcon size={18} />
  </button>
);

export type ButtonProps = DefaultProps & {
  active: boolean;
  customDataAttrGtmClick?: CustomDataAttrGtmClick;
};

export const ButtonFavorite: FC<ButtonProps> = ({
  active,
  customDataAttrGtmClick,
}) => {
  switch (active) {
    case true:
      return <ButtonFavoriteActive data-gtm-click={customDataAttrGtmClick} />;
    case false:
      return <ButtonFavoriteDefault data-gtm-click={customDataAttrGtmClick} />;
    default:
      return assertNever(active);
  }
};
